import { FormValues } from '../types';

const buildAndPostForm = (url: string, data: FormValues) => {
    const form = document.createElement('form');

    form.setAttribute('method', 'post');
    form.setAttribute('action', url);

    Object.entries(data).forEach(([fieldId, fieldValue]) => {
        const inputElem = document.createElement('input');

        inputElem.setAttribute('type', 'hidden');
        inputElem.setAttribute('name', fieldId);

        let value = fieldValue;

        if (!value) {
            value = '';
        } else {
            value = value.toString();
        }

        inputElem.setAttribute('value', value);

        form.appendChild(inputElem);
    });

    document.body.appendChild(form);

    form.submit();
};

export default buildAndPostForm;
